import apiFetch from '../apiFetch'

export default function (token, financingTypeId) {
  return apiFetch({ endPoint: `FinancingTypes/${financingTypeId}`, method: 'GET', body: null, token: token })
}
